import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import GreenDotted from '../assets/GreenDotted.svg'
import { pressHotkeys } from '../helpers/utils'
import { CircularProgress } from './CircularProgress'

const WrapperLink = styled(NavLink)`
  height: 200px;
  width: 168px;
  border-radius: 16px;

  margin: 12px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;

  background: url(${GreenDotted}) center no-repeat;

  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.08);

  @media (max-width: 450px) {
    height: 156px;
    width: 129px;
    margin: 5px;
  }
`

const Text = styled.span`
  display: block;
  text-transform: uppercase;
  color: #221f20;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  width: 85%;
  margin: 16px auto 0 auto;
`

const Badge = ({
  wrpStyle, icon, title, onClick, progress,
}) => (
  <WrapperLink
    role='link'
    tabIndex="0"
    aria-label={`${title} ${progress}% tutorial completed`}
    to={onClick}
    style={wrpStyle}
    onKeyDown={pressHotkeys}
  >
    <CircularProgress
      progress={progress || 0}
      name={title}
      iconPath={icon}
    />
    <Text aria-hidden="true">{title}</Text>
  </WrapperLink>
)

export default Badge
